import { Order } from 'utils/types/order';

export const getInstallmentOption = (order: Order, installment?: number) =>
    order?.payment?.installmentOptions?.find(
        (option) => option?.installment === installment
    );

/**
 * Valor efetivamente cobrado (parcela x numero de parcelas).
 * Mantem o contrato do datalayer: undefined quando nao ha parcela definida.
 */
export const getFinalPrice = (order: Order, installment?: number) => {
    const option = getInstallmentOption(order, installment);

    return option?.amount * installment || undefined;
};

/** reais -> centavos (inteiro), como a OpenAI exige em `amount` */
export const toMinorUnits = (value: number) => Math.round(value * 100);
